import { render, staticRenderFns } from "./AlphaDetailTable.vue?vue&type=template&id=1cc5aa17"
import script from "./AlphaDetailTable.vue?vue&type=script&lang=js"
export * from "./AlphaDetailTable.vue?vue&type=script&lang=js"
import style0 from "./AlphaDetailTable.vue?vue&type=style&index=0&id=1cc5aa17&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports